import React, { useEffect, useRef } from 'react';
import Header from '../components/layout/Header';
import { useLoading } from '../context/LoadingContext';
import Loader from '../components/ui/Loader';
import Toast from '../components/ui/Toast';
import Footer from '../components/layout/Footer';
import { useHeaderContext } from '../context/HeaderContext';
import { useFooterContext } from '../context/FooterContext';

export default function Layout({ children }) {
  const { isLoading } = useLoading();
  const { headerHeight, setHeaderHeight } = useHeaderContext();
  const { footerHeight, setFooterHeight } = useFooterContext();
  const headerRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }

    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
    }

    const handleResize = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
      if (footerRef.current) {
        setFooterHeight(footerRef.current.offsetHeight);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setFooterHeight, setHeaderHeight]);

  return (
    <>
      <Header ref={headerRef} />

      <main style={{ paddingTop: `${headerHeight}px`, paddingBottom: `${footerHeight}px` }} className="h-screen">
        {children}
      </main>

      <Footer ref={footerRef} />

      <Toast />

      {isLoading && <Loader text="Chargement des données en cours... Merci de votre patience 😊" />}
    </>
  );
}
